import { LOCATION_CHANGE_HANDLE } from '../lib/redux-router';

import ActionTypes from '../constants/ActionTypes';
import ModalTypes from '../constants/ModalTypes';

const initialState = {
  isLogouting: false,
  currentModal: null,
  currentModalData: null,
  listTransferPrepare: null,
  listTransferPointSystemPrompt: null,
  cardTransferPointSystemPrompt: null,
  cardTransferStatus: null,
};

// eslint-disable-next-line default-param-last
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LOCATION_CHANGE_HANDLE:
    case ActionTypes.MODAL_CLOSE:
      return {
        ...state,
        currentModal: null,
        currentModalData: null,
      };
    case ActionTypes.LOGOUT__ACCESS_TOKEN_INVALIDATE:
      return {
        ...state,
        isLogouting: true,
      };
    case ActionTypes.MODAL_OPEN:
      return {
        ...state,
        currentModal: payload.type,
        currentModalData: payload.data || null,
      };
    case ActionTypes.LIST_TRANSFER_PREPARE:
      return {
        ...state,
        listTransferPrepare: {
          listId: payload.listId,
          boardId: payload.boardId,
          status: 'pending',
          users: [],
          pointSystem: null,
          error: null,
        },
      };
    case ActionTypes.LIST_TRANSFER_PREPARE__SUCCESS:
      return {
        ...state,
        listTransferPrepare: {
          listId: payload.listId,
          boardId: payload.boardId,
          status: 'success',
          users: payload.users || [],
          pointSystem: payload.pointSystem || null,
          error: null,
        },
      };
    case ActionTypes.LIST_TRANSFER_PREPARE__FAILURE:
      return {
        ...state,
        listTransferPrepare: {
          listId: payload.listId,
          boardId: payload.boardId,
          status: 'failure',
          users: [],
          pointSystem: null,
          error: payload.error || null,
        },
      };
    case ActionTypes.LIST_TRANSFER_PREPARE_CLEAR:
      return {
        ...state,
        listTransferPrepare: null,
      };
    case ActionTypes.LIST_TRANSFER_POINT_SYSTEM_PROMPT:
      return {
        ...state,
        listTransferPointSystemPrompt: payload || null,
      };
    case ActionTypes.LIST_TRANSFER_POINT_SYSTEM_PROMPT_CLEAR:
      return {
        ...state,
        listTransferPointSystemPrompt: null,
      };
    case ActionTypes.CARD_TRANSFER_POINT_SYSTEM_PROMPT:
      return {
        ...state,
        cardTransferPointSystemPrompt: payload || null,
      };
    case ActionTypes.CARD_TRANSFER_POINT_SYSTEM_PROMPT_CLEAR:
      return {
        ...state,
        cardTransferPointSystemPrompt: null,
      };
    case ActionTypes.CARD_TRANSFER:
      return {
        ...state,
        cardTransferStatus: {
          cardId: payload.cardId,
          status: 'pending',
          message: null,
          prompted: false,
        },
      };
    case ActionTypes.CARD_TRANSFER__SUCCESS:
      return {
        ...state,
        cardTransferStatus: {
          cardId: payload.cardId,
          status: 'success',
          message: null,
          prompted: Boolean(payload.prompted),
        },
      };
    case ActionTypes.CARD_TRANSFER__FAILURE:
      return {
        ...state,
        cardTransferStatus: {
          cardId: payload.cardId,
          status: 'failure',
          message: payload.message || 'Не удалось переместить карточку. Попробуйте ещё раз.',
          prompted: false,
        },
      };
    case ActionTypes.CARD_TRANSFER_STATUS_CLEAR:
      return {
        ...state,
        cardTransferStatus: null,
      };
    case ActionTypes.USER_UPDATE_HANDLE:
      if (state.currentModal === ModalTypes.USERS && payload.isCurrent && !payload.user.isAdmin) {
        return {
          ...state,
          currentModal: null,
        };
      }

      return state;
    case ActionTypes.PROJECT_MANAGER_DELETE:
    case ActionTypes.PROJECT_MANAGER_DELETE_HANDLE:
      if (
        state.currentModal === ModalTypes.PROJECT_SETTINGS &&
        payload.isCurrentUser &&
        payload.isCurrentProject
      ) {
        return {
          ...state,
          currentModal: null,
        };
      }

      return state;
    default:
      return state;
  }
};
